import { CvPage } from "@/features/cv/CvPage";
import "./index.css";

export function App() {
  return <CvPage />;
}

export default App;
